import AbstractChart from './abstract_chart';

class BenefitsWaterfallChart extends AbstractChart {
  options() {
    return $.extend(true, this.defaultOptions(), this.standard_waterfall_options(), this.custom_waterfall_options());
  }

  total_value_translation() {
    if (this.model.lang() === 'de') { return 'Gesamtwert'; }
    if (this.model.lang() === 'es') { return 'Valor total'; }
    if (this.model.lang() === 'fr') { return 'Valeur totale'; }
    if (this.model.lang() === 'pt') { return 'Valor total'; }

    return 'Total value';
  }

  standard_waterfall_options() {
    const that = this; // for formatter() below
    return {
      chart: {
        height: 500,
        name: 'Benefits',
        type: 'waterfall',
      },
      legend: { enabled: false },
      series: this.createSeries(),
      tooltip: {
        formatter() {
          return `${this.key}: ${accounting.formatMoney(this.y.toFixed(0), that.model.currency_symbol(), 0, that.model.currency_thousand_separator(), that.model.currency_decimal_separator())}`;
        },
        pointFormat: '<b>{point.percentage:.1f}%</b>'
      },
      xAxis: {
        labels: {
          rotation: -45,
          style: { textOverflow: 'none' },
        },
        type: 'category'
      },
      yAxis: {
        labels: {
          overflow: 'justify'
        },
        title: { text: that.model.currency_code() }, // TODO - update this
      }
    };
  }

  // can be overridden by child classes to implement custom options
  custom_waterfall_options() {
    return {};
  }

  asMoney(val) {
    if (this.model.chart_waterfall_money_units() === 'M') {
      return `${accounting.formatMoney((val / 1000 / 1000).toFixed(2), this.model.currency_symbol(), 2, this.model.currency_thousand_separator(), this.model.currency_decimal_separator())}M`;
    }

    return `${accounting.formatMoney((val / 1000).toFixed(0), this.model.currency_symbol(), 0, this.model.currency_thousand_separator(), this.model.currency_decimal_separator())}k`;
  }

  createSeries() {
    const that = this; // for formatter() below
    const tv = this.total_value_translation();

    return [{
      data: this.createData(),
      dataLabels: {
        enabled: true,
        formatter() {
          if (this.key === that.total_value_translation()) {
           return `<span style="color: ${that.model.chart_waterfall_total_value_color()};">${that.asMoney(this.y)}</span>`;
          }

          return `<span style="color: ${that.model.chart_waterfall_value_color()};">${that.asMoney(this.y)}</span>`;
        }
      },
      pointPadding: 0
    }
    ];
  }

  createData() {
    const data = [];
    let total = 0;
    // eslint-disable-next-line no-restricted-syntax
    for (const benefit of Array.from(this.model.cumulative_value_by_benefit_for_chart(null, true))) {
      total += benefit[1];
      data.push({ name: benefit[0], y: benefit[1] });
    }

    data.push({ name: this.total_value_translation(), y: total, isIntermediateSum: true });
    return data;
  }
}

export default BenefitsWaterfallChart;
